import { useLocation } from 'react-router-dom'
import { YeshumanConceptsTopologyPage } from '@/components/landing/yeshuman/yeshuman-concepts-topology-page'
import { YeshumanConceptsWordsPage } from '@/components/landing/yeshuman/yeshuman-concepts-words-page'
import {
  YESHUMAN_CONCEPTS_PATH,
  YESHUMAN_CONCEPTS_TOPOLOGY_PATH,
} from '@/constants/yeshuman-marketing-routes'

export function YeshumanConceptsRoutes() {
  const { pathname } = useLocation()

  if (pathname === YESHUMAN_CONCEPTS_TOPOLOGY_PATH) {
    return <YeshumanConceptsTopologyPage />
  }
  if (pathname === YESHUMAN_CONCEPTS_PATH) {
    return <YeshumanConceptsWordsPage />
  }

  return null
}
